import paymentActions from 'features/payment/services/actions';
import paymentSelectors from 'features/payment/services/selectors';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import shopSelectors from 'services/shop/selectors';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';
import ReceiptUI from '../CheckInPrinter/ReceiptUI';
import { IInfoPrinterWaitingResData } from 'features/payment/services/types/ticket';
type CheckInGroupPrinterRef = {
  print: (data: IInfoPrinterWaitingResData[] | null) => void;
};
export const checkInGroupPrinter = React.createRef<CheckInGroupPrinterRef>();
const CheckInGroupPrinter = forwardRef<CheckInGroupPrinterRef>((_props, ref) => {
  const setting = shopSelectors.data.allSetting();
  const [data, setData] = useState<IInfoPrinterWaitingResData[] | null>(null);
  const divRef = useRef<HTMLDivElement>(null);
  const doPrint = useReactToPrint({
    content: () => divRef.current, onAfterPrint() {
      setData((null));
    },
  });

  useImperativeHandle(ref, () => ({
    print: (_data) => {
      if (!setting?.enablePrintCheckIn) return;
      if (!_data) return;
      setData(_data);
      setTimeout(() => doPrint(), 10);
    }
  }));

  if (storage.device_type.get() !== 'POS') return null;

  if (!setting?.enablePrintCheckIn) return null;


  return (
    <CheckInPrinterStyled style={{ display: 'none' }}>
      <div ref={divRef}>
        {data?.map((item, index) => (
          <ReceiptUI data={item} key={index} />
        ))}
      </div>

    </CheckInPrinterStyled>
  );
});
CheckInGroupPrinter.displayName = 'CheckInGroupPrinter';
export default CheckInGroupPrinter;

const CheckInPrinterStyled = styled.div`
  // position: fixed;
  // inset: 0;
  // index: 999999;
  // background: red;

  .container {
    padding:0 1rem;
  }
`;